import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4.25 11.717-2.314 2.83a.447.447 0 0 0 .162.69l2.187.985c.16.072.264.232.264.408v2.198c0 .783.606 1.439 1.388 1.487.989.062 1.969.092 2.937-.01q.06-.008.12-.013m0 0c.826-.08 1.521-.076 2.49-.67C12.5 19 12.5 17.1 10.5 17.5c-1.225.245-1.61 1.45-1.507 2.792m0 0c.056.74.26 1.522.555 2.208"
    />
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="m14.408 17.216.245-1.87a1.51 1.51 0 0 0-1.3-1.694l-.957-.125a2.053 2.053 0 0 1-1.768-2.303l.101-.77c.073-.558.585-.951 1.143-.878M10.372 11.434a2.717 2.717 0 1 1 .707-5.387M16.325 11.303a2.264 2.264 0 1 0 3.905-1.245"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M17.412 6.077a2.49 2.49 0 0 1 1.885 4.469"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M17.305 7.321a3.17 3.17 0 1 0-6.285-.825l-.117.898"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M10.205 1.76c-1.879-.126-5.647.733-5.688 5.18C4.5 8.63 4.505 8.88 4.419 9.785"
    />
  </svg>
);
export const IntellectIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
